import AdminPublicProfile from '../components/AdminPublicProfile';
import PsychologistPublicLink from '../components/PsychologistPublicLink';
import { FreeAccessSettings, AccessSummary } from '../components/PsychologistAccess';
import { displayResponseStatus } from '../utils/timeoutState';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API, AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Textarea } from '../components/ui/textarea';
import { Brain, LogOut, Users, Settings, Trash2, UserPlus, UserCheck, FileText, Lock, Key, MessageCircle, CheckCircle, Clock, IndianRupee } from 'lucide-react';
import NotificationModal from '../components/NotificationModal';
import { useNotification } from '../hooks/useNotification';
import Pagination from '../components/Pagination';
import AccountSettings from '../components/AccountSettings';
import ConsentModal from '../components/ConsentModal';
import ReportPromptsManager from '../components/ReportPromptsManager';

import { withDoctorTitle } from '../utils/doctorTitle';
const AdminDashboard = () => {
  const [publicPages, setPublicPages] = useState({});
  useEffect(() => {
    axios.get(`${API}/admin/psychologist-public-pages`).then(res => setPublicPages(Object.fromEntries(res.data.map(page => [page.id, page])))).catch(() => {});
  }, []);

  const navigate = useNavigate();
  const { notification, showSuccess, showError, showInfo, showWarning, closeNotification } = useNotification();
  const { user, logout } = useContext(AuthContext);
  
  // Consent Modal State
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [activeTab, setActiveTab] = useState('psychologists');
  const [psychologistsTab, setPsychologistsTab] = useState('list');
  const [paymentsTab, setPaymentsTab] = useState('history');
  
  // Payment History states
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [paymentSearchQuery, setPaymentSearchQuery] = useState('');
  const [paymentFromDate, setPaymentFromDate] = useState('');
  const [paymentToDate, setPaymentToDate] = useState('');
  const [paymentCurrentPage, setPaymentCurrentPage] = useState(1);
  const [paymentTotalPages, setPaymentTotalPages] = useState(0);
  const [paymentTotalRecords, setPaymentTotalRecords] = useState(0);
  const paymentsPerPage = 20;
  const [pendingConsultations, setPendingConsultations] = useState([]);
  const [loadingPendingConsultations, setLoadingPendingConsultations] = useState(false);
  const [waivingConsultationId, setWaivingConsultationId] = useState(null);
  // Waive-payment confirmation dialog (captures optional reason)
  const [waiveDialogOpen, setWaiveDialogOpen] = useState(false);
  const [waiveTarget, setWaiveTarget] = useState(null); // consultation object
  const [waiveReason, setWaiveReason] = useState('');

  
  const [users, setUsers] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [settings, setSettings] = useState(null);
  const [adminSettings, setAdminSettings] = useState(null);
  const [savedValiditySettings, setSavedValiditySettings] = useState(null);
  const [showAddUser, setShowAddUser] = useState(false);
  const [newUser, setNewUser] = useState({ email: '', password: '', name: '', role: 'client', license_number: '' });
  const [wordsText, setWordsText] = useState('');
  const [viewingQaThread, setViewingQaThread] = useState(null);
  const [showQaThreadModal, setShowQaThreadModal] = useState(false);
  const [adminReply, setAdminReply] = useState('');
  const [sendingReply, setSendingReply] = useState(false);
  const [endingChat, setEndingChat] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showFeedbackReplyModal, setShowFeedbackReplyModal] = useState(false);
  const [feedbackReply, setFeedbackReply] = useState('');
  const [sendingFeedbackReply, setSendingFeedbackReply] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [changingPassword, setChangingPassword] = useState(false);
  const [feedback, setFeedback] = useState([]);
  const [feedbackItemsPerPage, setFeedbackItemsPerPage] = useState(10);
  const [analytics, setAnalytics] = useState(null);
  const [loadingAnalytics, setLoadingAnalytics] = useState(false);
  const [assignmentsPage, setAssignmentsPage] = useState(1);
  const [feedbackPage, setFeedbackPage] = useState(1);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [psychologistSearchTerm, setPsychologistSearchTerm] = useState('');
  const [showUnassignedOnly, setShowUnassignedOnly] = useState(false);
  const [showUnassignedPsychologists, setShowUnassignedPsychologists] = useState(false);
  const [qaThreads, setQaThreads] = useState([]);
  const [loadingQaThreads, setLoadingQaThreads] = useState(false);
  const [qaPage, setQaPage] = useState(1);
  const [qaSearchTerm, setQaSearchTerm] = useState('');
  const [showDeleteFeedbackModal, setShowDeleteFeedbackModal] = useState(false);
  const [selectedFeedbackForDelete, setSelectedFeedbackForDelete] = useState(null);
  const [deletingFeedback, setDeletingFeedback] = useState(false);
  
  // Psychologist approval states
  const [pendingPsychologists, setPendingPsychologists] = useState([]);
  const [allPsychologists, setAllPsychologists] = useState([]);
  const [loadingPsychologists, setLoadingPsychologists] = useState(false);
  const [psychologistFilterStatus, setPsychologistFilterStatus] = useState('all'); // 'all', 'active', 'deactivated'
  const [psychologistSearchQuery, setPsychologistSearchQuery] = useState('');
  const [psychologistPage, setPsychologistPage] = useState(1);
  const [psychologistsPerPage] = useState(5);
  const [selectedPsychologist, setSelectedPsychologist] = useState(null);
  const [showPsychologistDetailModal, setShowPsychologistDetailModal] = useState(false);
  const [approvingPsychologist, setApprovingPsychologist] = useState(false);
  
  // Pending approvals pagination
  const [pendingApprovalPage, setPendingApprovalPage] = useState(1);
  const [pendingApprovalPerPage] = useState(5);
  const [pendingSearchQuery, setPendingSearchQuery] = useState('');
  
  // Users tab pagination
  const [clientsPage, setClientsPage] = useState(1);
  const [clientsPerPage] = useState(5);
  const [clientsSearchQuery, setClientsSearchQuery] = useState('');
  const [psychologistsUserPage, setPsychologistsUserPage] = useState(1);
  const [psychologistsUserPerPage] = useState(5);
  const [psychologistsUserSearchQuery, setPsychologistsUserSearchQuery] = useState('');
  
  // Moral story states
  const [moralStoryContent, setMoralStoryContent] = useState('');
  const [savingMoralStory, setSavingMoralStory] = useState(false);
  
  const itemsPerPage = 20;

  useEffect(() => {
    // Check if user has given consent
    if (!user?.consent_accepted) {
      setShowConsentModal(true);
    }
    
    fetchUsers();
    fetchSessions();
    fetchSettings();
    fetchAdminSettings();
    fetchFeedback();
    fetchAnalytics();
    fetchQaThreads();
    fetchPendingPsychologists();
    fetchAllPsychologists();
  }, []);

  // Refresh the selected view for both pointer and keyboard tab activation.
  const selectPsychologistsTab = (value) => {
    setPsychologistsTab(value);
    if (value === 'approval') fetchPendingPsychologists();
    else fetchAllPsychologists();
  };

  const selectPaymentsTab = (value) => {
    setPaymentsTab(value);
    if (value === 'pending-payments') fetchPendingConsultations();
    else fetchPaymentHistory(paymentCurrentPage, paymentSearchQuery, paymentFromDate, paymentToDate);
  };

  const selectAdminTab = (value) => {
    setActiveTab(value);
    if (value === 'psychologists') selectPsychologistsTab(psychologistsTab);
    if (value === 'payments') selectPaymentsTab(paymentsTab);
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API}/admin/users`);
      setUsers(res.data);
    } catch (error) {
      showError('Failed to load users');
    }
  };

  const handleToggleActivation = async (userId, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await axios.patch(`${API}/admin/users/${userId}/activation`, {
        is_active: newStatus
      });
      showSuccess(`Psychologist ${newStatus ? 'activated' : 'deactivated'} successfully`);
      
      // Close modal
      setShowPsychologistDetailModal(false);
      
      // Refresh all psychologist data
      await fetchUsers();
      await fetchAllPsychologists();
      await fetchPendingPsychologists();
      
    } catch (error) {
      showError(error.response?.data?.detail || `Failed to ${currentStatus ? 'deactivate' : 'activate'} psychologist`);
      console.error('Toggle activation error:', error);
    }
  };

  const fetchSessions = async () => {
    try {
      const res = await axios.get(`${API}/admin/sessions`);
      setSessions(res.data);
    } catch (error) {
      showError('Failed to load sessions');
    }
  };

  const fetchSettings = async () => {
    try {
      const token = sessionStorage.getItem('token');
      // Fetch from /settings (not /admin/settings) to get Phase configurations
      const response = await axios.get(`${API}/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSettings(response.data);
      if (response.data.phase3_words) {
        setWordsText(response.data.phase3_words.join(', '));
      }
      if (response.data.moral_story && response.data.moral_story.content) {
        setMoralStoryContent(response.data.moral_story.content);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      showError('Failed to load settings');
    }
  };

  const fetchAdminSettings = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${API}/admin/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdminSettings(response.data);
      setSavedValiditySettings({
        analysis_always_valid: response.data.analysis_always_valid === true,
        assessment_validity_days: response.data.assessment_validity_days || 90
      });
    } catch (error) {
      console.error('Error fetching admin settings:', error);
      showError('Failed to load admin settings');
    }
  };

  const updateAdminSettings = async (updates) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.patch(`${API}/admin/settings`, updates, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdminSettings(response.data.settings);
      if ('analysis_always_valid' in updates || 'assessment_validity_days' in updates) {
        setSavedValiditySettings({
          analysis_always_valid: response.data.settings.analysis_always_valid === true,
          assessment_validity_days: response.data.settings.assessment_validity_days || 90
        });
      }
      showSuccess('Settings updated successfully');
    } catch (error) {
      console.error('Error updating admin settings:', error);
      showError(error.response?.data?.detail || 'Failed to update settings');
    }
  };

  const fetchPaymentHistory = async (page = 1, search = '', fromDate = '', toDate = '') => {
    setLoadingPayments(true);
    try {
      const token = sessionStorage.getItem('token');
      const params = {
        page: page,
        limit: paymentsPerPage,
        search: search
      };
      
      // Add date filters if provided
      if (fromDate) params.from_date = fromDate;
      if (toDate) params.to_date = toDate;
      
      const response = await axios.get(`${API}/admin/payment-history`, {
        headers: { Authorization: `Bearer ${token}` },
        params: params
      });
      
      setPaymentHistory(response.data.payments || []);
      setPaymentTotalPages(response.data.total_pages || 0);
      setPaymentTotalRecords(response.data.total_records || 0);
      setPaymentCurrentPage(page);
    } catch (error) {
      console.error('Error fetching payment history:', error);
      showError('Failed to fetch payment history');
      setPaymentHistory([]);
    } finally {
      setLoadingPayments(false);
    }
  };

  const fetchPendingConsultations = async () => {
    setLoadingPendingConsultations(true);
    try {
      const token = sessionStorage.getItem('token');
      const res = await axios.get(`${API}/consultations`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { status: 'payment_pending' },
      });
      // Backend may return list or {consultations: [...]}
      const list = Array.isArray(res.data) ? res.data : (res.data.consultations || []);
      // Keep only payment_pending items in case the backend ignored the filter
      setPendingConsultations(list.filter(c => c.status === 'payment_pending'));
    } catch (error) {
      console.error('Error fetching pending consultations:', error);
      showError('Failed to fetch pending payment consultations');
      setPendingConsultations([]);
    } finally {
      setLoadingPendingConsultations(false);
    }
  };

  const openWaiveDialog = (consultation) => {
    setWaiveTarget(consultation);
    setWaiveReason('');
    setWaiveDialogOpen(true);
  };
  
  const closeWaiveDialog = () => {
    if (waivingConsultationId) return; // Prevent close during request
    setWaiveDialogOpen(false);
    setWaiveTarget(null);
    setWaiveReason('');
  };
  
  const confirmWaivePayment = async () => {
    if (!waiveTarget) return;
    const consultationId = waiveTarget.id;
    setWaivingConsultationId(consultationId);
    try {
      const token = sessionStorage.getItem('token');
      const res = await axios.post(
        `${API}/admin/consultations/${consultationId}/waive-payment`,
        { reason: waiveReason.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      showSuccess(res.data.message || 'Payment waived and consultation approved.');
      setWaiveDialogOpen(false);
      setWaiveTarget(null);
      setWaiveReason('');
      await fetchPendingConsultations();
    } catch (error) {
      console.error('Waive payment failed:', error);
      showError(error.response?.data?.detail || 'Failed to waive payment');
    } finally {
      setWaivingConsultationId(null);
    }
  };
  
  // Legacy handler retained for API compatibility (no longer bound to any button)
  const waiveConsultationPayment = (consultationId) => {
    const target = pendingConsultations.find((c) => c.id === consultationId);
    if (target) openWaiveDialog(target);
  };

  const fetchFeedback = async () => {
    try {
      const res = await axios.get(`${API}/admin/feedback`);
      setFeedback(res.data);
    } catch (error) {
      showError('Failed to load feedback');
    }
  };

  const fetchAnalytics = async () => {
    setLoadingAnalytics(true);
    try {
      const res = await axios.get(`${API}/admin/analytics`);
      setAnalytics(res.data);
    } catch (error) {
      showError('Failed to load analytics');
    } finally {
      setLoadingAnalytics(false);
    }
  };

  const fetchPendingPsychologists = async () => {
    setLoadingPsychologists(true);
    try {
      const res = await axios.get(`${API}/admin/psychologists/pending`);
      setPendingPsychologists(res.data);
    } catch (error) {
      showError('Failed to load pending psychologists');
    } finally {
      setLoadingPsychologists(false);
    }
  };

  const fetchAllPsychologists = async () => {
    setLoadingPsychologists(true);
    try {
      const res = await axios.get(`${API}/admin/psychologists`);
      setAllPsychologists(res.data);
    } catch (error) {
      showError('Failed to load psychologists');
    } finally {
      setLoadingPsychologists(false);
    }
  };

  const approvePsychologist = async (psychologistId) => {
    setApprovingPsychologist(true);
    try {
      await axios.post(`${API}/admin/psychologists/${psychologistId}/approve`);
      showSuccess('Psychologist approved successfully');
      fetchPendingPsychologists();
      fetchAllPsychologists();
    } catch (error) {
      showError('Failed to approve psychologist');
    } finally {
      setApprovingPsychologist(false);
    }
  };

  const rejectPsychologist = async (psychologistId) => {
    setApprovingPsychologist(true);
    try {
      await axios.post(`${API}/admin/psychologists/${psychologistId}/reject`);
      showSuccess('Psychologist rejected');
      fetchPendingPsychologists();
      fetchAllPsychologists();
    } catch (error) {
      showError('Failed to reject psychologist');
    } finally {
      setApprovingPsychologist(false);
    }
  };


  const updateFeedbackStatus = async (feedbackId, status) => {
    try {
      await axios.put(`${API}/admin/feedback/${feedbackId}/status?status=${status}`);
      showSuccess('Feedback status updated');
      fetchFeedback();
    } catch (error) {
      showError('Failed to update status');
    }
  };

  const handleDeleteFeedbackClick = (feedback) => {
    setSelectedFeedbackForDelete(feedback);
    setShowDeleteFeedbackModal(true);
  };

  const confirmDeleteFeedback = async () => {
    if (!selectedFeedbackForDelete) return;
    
    setDeletingFeedback(true);
    try {
      await axios.delete(`${API}/admin/feedback/${selectedFeedbackForDelete.id}`);
      showSuccess('Feedback deleted successfully');
      setShowDeleteFeedbackModal(false);
      setSelectedFeedbackForDelete(null);
      fetchFeedback();
    } catch (error) {
      showError('Failed to delete feedback');
    } finally {
      setDeletingFeedback(false);
    }
  };

  const fetchQaThreads = async () => {
    setLoadingQaThreads(true);
    try {
      const res = await axios.get(`${API}/admin/qa-threads`);
      setQaThreads(res.data);
    } catch (error) {
      showError('Failed to load Q&A threads');
    } finally {
      setLoadingQaThreads(false);
    }
  };

  const deleteQaThread = async (questionId) => {
    try {
      await axios.delete(`${API}/admin/qa-threads/${questionId}`);
      showSuccess('Q&A thread deleted successfully');
      fetchQaThreads();
    } catch (error) {
      showError('Failed to delete Q&A thread');
    }
  };

  const closeQaThread = async (questionId) => {
    try {
      await axios.patch(`${API}/admin/qa-threads/${questionId}/close`);
      showSuccess('Chat closed successfully');
      fetchQaThreads();
    } catch (error) {
      showError('Failed to close chat');
    }
  };

  const downloadQaPdf = async (questionId) => {
    try {
      const response = await axios.get(`${API}/admin/qa-threads/${questionId}/pdf`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `qa_thread_${questionId.substring(0, 8)}.txt`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      showSuccess('Q&A thread downloaded');
    } catch (error) {
      console.error('Download error:', error);
      // Handle blob response errors properly
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          showError(errorData.detail || 'Failed to download Q&A thread');
        } catch (e) {
          showError('Failed to download Q&A thread');
        }
      } else {
        showError(error.response?.data?.detail || 'Failed to download Q&A thread');
      }
    }
  };

  const addUser = async () => {
    // Validate license number for psychologists
    if (newUser.role === 'psychologist') {
      if (!newUser.license_number || newUser.license_number.trim() === '') {
        showError('License number is required for psychologists');
        return;
      }
      if (newUser.license_number.length > 6) {
        showError('License number must be maximum 6 characters');
        return;
      }
      if (!/^[a-zA-Z0-9]+$/.test(newUser.license_number)) {
        showError('License number must be alphanumeric only');
        return;
      }
    }

    try {
      await axios.post(`${API}/admin/users`, newUser);
      showSuccess('User created');
      setShowAddUser(false);
      setNewUser({ email: '', password: '', name: '', role: 'client', license_number: '' });
      fetchUsers();
    } catch (error) {
      showError(error.response?.data?.detail || 'Failed to create user');
    }
  };

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`${API}/admin/users/${userId}`);
      showSuccess('User deleted');
      fetchUsers();
    } catch (error) {
      showError('Failed to delete user');
    }
  };

  const assignPsychologist = async (sessionId, psychologistId) => {
    try {
      await axios.patch(`${API}/sessions/${sessionId}/assign?psychologist_id=${psychologistId}`);
      showSuccess('Psychologist assigned');
      fetchSessions();
    } catch (error) {
      showError('Failed to assign psychologist');
    }
  };

  const updateSettings = async (updates) => {
    try {
      console.log('📤 [ADMIN] Sending timer updates to backend:', updates);
      const response = await axios.patch(`${API}/settings`, updates);
      console.log('✅ [ADMIN] Backend response:', response.data);
      showSuccess('Settings updated');
      await fetchSettings();
      if (Object.prototype.hasOwnProperty.call(updates, 'client_text_correction_enabled')) {
        window.localStorage.setItem('insight_client_settings_updated_at', String(Date.now()));
      }
      console.log('🔄 [ADMIN] Settings refetched from backend');
    } catch (error) {
      console.error('❌ [ADMIN] Failed to update settings:', error);
      showError('Failed to update settings');
    }
  };

  const saveMoralStory = async () => {
    if (!moralStoryContent.trim()) {
      showError('Moral story content cannot be empty');
      return;
    }
    setSavingMoralStory(true);
    try {
      // Update only the moral_story.content field
      await axios.patch(`${API}/settings`, {
        'moral_story.content': moralStoryContent
      });
      showSuccess('Moral story updated successfully');
      // No need to refetch - we already have the updated content in state
      // This prevents the textarea from reverting due to race conditions
    } catch (error) {
      showError('Failed to update moral story');
    } finally {
      setSavingMoralStory(false);
    }
  };

  const handleAdminReply = async () => {
    if (!adminReply.trim()) {
      showError('Please enter a reply');
      return;
    }

    setSendingReply(true);
    try {
      await axios.post(`${API}/questions/${viewingQaThread.id}/reply`, {
        message: adminReply.trim()
      });
      showSuccess('Reply sent successfully');
      setAdminReply('');
      // Refresh the thread
      fetchQaThreads();
      setShowQaThreadModal(false);
    } catch (error) {
      showError(error.response?.data?.detail || 'Failed to send reply');
    } finally {
      setSendingReply(false);
    }
  };

  const handleEndChat = async () => {
    setEndingChat(true);
    try {
      await axios.patch(`${API}/questions/${viewingQaThread.id}/end-chat`);
      showSuccess('Chat ended successfully');
      setAdminReply('');
      fetchQaThreads();
      setShowQaThreadModal(false);
    } catch (error) {
      showError(error.response?.data?.detail || 'Failed to end chat');
    } finally {
      setEndingChat(false);
    }
  };

  const handleFeedbackReply = async () => {
    if (!feedbackReply.trim()) {
      showError('Please enter a reply');
      return;
    }

    setSendingFeedbackReply(true);
    try {
      await axios.post(`${API}/admin/feedback/${selectedFeedback.id}/reply`, {
        admin_reply: feedbackReply.trim()
      });
      showSuccess('Reply sent successfully! User will see this message.');
      setFeedbackReply('');
      setShowFeedbackReplyModal(false);
      fetchFeedback(); // Refresh feedback list
    } catch (error) {
      showError(error.response?.data?.detail || 'Failed to send reply');
    } finally {
      setSendingFeedbackReply(false);
    }
  };

  const updateWords = () => {
    const words = wordsText.split(',').map(w => w.trim()).filter(w => w);
    updateSettings({ phase3_words: words });
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    if (newPassword !== confirmPassword) {
      showError('New passwords do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      showError('Password must be at least 6 characters');
      return;
    }
    
    setChangingPassword(true);
    try {
      await axios.put(`${API}/users/change-password`, {
        current_password: currentPassword,
        new_password: newPassword
      });
      showSuccess('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      showError(error.response?.data?.detail || 'Failed to change password');
    } finally {
      setChangingPassword(false);
    }
  };

  const resetUserPassword = async (userId, userName) => {
    try {
      const res = await axios.post(`${API}/admin/users/${userId}/reset-password`);
      const tempPassword = res.data.temporary_password;
      
      // Show temporary password in success message
      showSuccess(`Password reset successful for ${userName}!\n\nTemporary Password: ${tempPassword}\n\nPlease share this password with the user securely.`);
    } catch (error) {
      showError('Failed to reset password');
    }
  };

  const clients = users.filter(u => u.role === 'client');
  const psychologists = users.filter(u => u.role === 'psychologist');

  return (
    <div className="min-h-screen bg-white" data-testid="admin-dashboard">
      <nav className="px-8 py-6 flex justify-between items-center bg-white border-b border-gray-100 shadow-sm">
        <div className="flex items-center space-x-2">
          <img src="/insight-logo.png" alt="INSIGHT Logo" className="h-16" />
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-gray-600">{user?.name}</span>
          <Button variant="ghost" onClick={() => setActiveTab('account')} className="text-gray-600 hover:text-gray-800">
            <Lock className="w-4 h-4 mr-2" /> Account
          </Button>
          <Button variant="ghost" onClick={() => setActiveTab('feedback')} className="text-gray-600 hover:text-gray-800">
            <MessageCircle className="w-4 h-4 mr-2" /> Feedback
          </Button>
          <Button variant="ghost" onClick={logout} data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Logout
          </Button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-4xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Administration</h2>
          <div className="flex gap-3">
            <Link to="/admin/professional-stories"><Button variant="outline">Psychologist Success Stories</Button></Link>
            <Link to="/admin/psychologist-plans"><Button variant="outline">Psychologist Plans</Button></Link>
            <Link to="/admin/ai-usage"><Button variant="outline">AI Usage &amp; Reports</Button></Link>
            <Link to="/admin/llm-settings">
              <Button 
                variant="outline" 
                data-testid="llm-config-btn"
              >
                <Settings className="w-4 h-4 mr-2" /> LLM Configuration
              </Button>
            </Link>
            <Dialog open={showAddUser} onOpenChange={setShowAddUser}>
              <DialogTrigger asChild>
                <Button data-testid="add-user-btn">
                  <UserPlus className="w-4 h-4 mr-2" /> Add User
                </Button>
              </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Create New User</DialogTitle>
              </DialogHeader>
              <div className="space-y-4 mt-4">
                <div>
                  <Label>Name</Label>
                  <Input value={newUser.name} onChange={(e) => setNewUser({ ...newUser, name: e.target.value })} data-testid="new-user-name" />
                </div>
                <div>
                  <Label>Email</Label>
                  <Input type="email" value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} data-testid="new-user-email" />
                </div>
                <div>
                  <Label>Password</Label>
                  <Input type="password" value={newUser.password} onChange={(e) => setNewUser({ ...newUser, password: e.target.value })} data-testid="new-user-password" />
                </div>
                <div>
                  <Label>Role</Label>
                  <Select value={newUser.role} onValueChange={(val) => setNewUser({ ...newUser, role: val })}>
                    <SelectTrigger data-testid="new-user-role">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="client">Client</SelectItem>
                      <SelectItem value="psychologist">Psychologist</SelectItem>
                      <SelectItem value="admin">Admin</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                {newUser.role === 'psychologist' && (
                  <div>
                    <Label>RCI CRR No / License No <span className="text-red-500">*</span></Label>
                    <Input 
                      value={newUser.license_number} 
                      onChange={(e) => setNewUser({ ...newUser, license_number: e.target.value.toUpperCase() })} 
                      placeholder="ABC123"
                      maxLength={6}
                      required
                      data-testid="new-user-license"
                    />
                    <p className="text-xs text-gray-500 mt-1">Maximum 6 alphanumeric characters</p>
                  </div>
                )}
                <Button onClick={addUser} className="w-full" data-testid="create-user-btn">Create User</Button>
              </div>
            </DialogContent>
          </Dialog>
          </div>
        </div>

        <Tabs value={activeTab} onValueChange={selectAdminTab} className="w-full">
          <TabsList className="flex flex-wrap h-auto w-full gap-2 mb-8">
            <TabsTrigger value="psychologists" data-testid="tab-psychologists">
              <Brain className="w-4 h-4 mr-2" /> Manage Psychologists
            </TabsTrigger>
            <TabsTrigger value="users" data-testid="tab-users"><Users className="w-4 h-4 mr-2" /> Users</TabsTrigger>
            <TabsTrigger value="qa" data-testid="tab-qa"><MessageCircle className="w-4 h-4 mr-2" /> Q&A Management</TabsTrigger>
            <TabsTrigger value="payments" data-testid="tab-payments">
              <IndianRupee className="w-4 h-4 mr-2" /> Historical Client Payments
            </TabsTrigger>
            <TabsTrigger value="report-prompts" data-testid="tab-report-prompts"><FileText className="w-4 h-4 mr-2" /> Analysis Prompts</TabsTrigger>
            <TabsTrigger value="settings" data-testid="tab-settings"><Settings className="w-4 h-4 mr-2" /> Settings</TabsTrigger>
            <TabsTrigger value="account" data-testid="tab-account" style={{ display: 'none' }}><Lock className="w-4 h-4 mr-2" /> Account</TabsTrigger>
            <TabsTrigger value="feedback" data-testid="tab-feedback" style={{ display: 'none' }}><MessageCircle className="w-4 h-4 mr-2" /> Feedback</TabsTrigger>
          </TabsList>

          {/* Analytics section removed */}




          <TabsContent value="psychologists">
            <Tabs value={psychologistsTab} onValueChange={selectPsychologistsTab}>
              <TabsList aria-label="Manage Psychologists" className="flex flex-wrap h-auto w-full justify-start gap-2 mb-4">
                <TabsTrigger value="list">Psychologist List</TabsTrigger>
                <TabsTrigger value="approval" data-testid="tab-approval">
                  <UserPlus className="w-4 h-4 mr-2" /> Psychologist Approval
                </TabsTrigger>
              </TabsList>
          <TabsContent value="list" data-testid="psychologists-content">
            <Card>
              <CardHeader>
                <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  Manage All Psychologists
                </CardTitle>
              </CardHeader>
              <CardContent>
                {/* Search and Filter Controls */}
                <div className="mb-6 space-y-4">
                  {/* Search Box */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="🔍 Search by name, specialization, license number, email..."
                      value={psychologistSearchQuery}
                      onChange={(e) => setPsychologistSearchQuery(e.target.value)}
                      className="w-full px-4 py-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    {psychologistSearchQuery && (
                      <button
                        onClick={() => setPsychologistSearchQuery('')}
                        className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                  
                  {/* Filter Buttons */}
                  <div className="flex gap-3 flex-wrap">
                    <button
                      onClick={() => setPsychologistFilterStatus('all')}
                      className={`px-4 py-2 rounded-lg font-medium transition-all ${
                        psychologistFilterStatus === 'all'
                          ? 'bg-blue-600 text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      All Psychologists
                    </button>
                    <button
                      onClick={() => setPsychologistFilterStatus('active')}
                      className={`px-4 py-2 rounded-lg font-medium transition-all ${
                        psychologistFilterStatus === 'active'
                          ? 'bg-green-600 text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      ✓ Active Only
                    </button>
                    <button
                      onClick={() => setPsychologistFilterStatus('deactivated')}
                      className={`px-4 py-2 rounded-lg font-medium transition-all ${
                        psychologistFilterStatus === 'deactivated'
                          ? 'bg-gray-600 text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      ✕ Deactivated Only
                    </button>
                  </div>
                  
                  {/* Results Count */}
                  <div className="text-sm text-gray-600">
                    Showing {allPsychologists.filter(p => {
                      // Filter by status
                      const statusMatch = 
                        psychologistFilterStatus === 'all' ? true :
                        psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                        (p.is_active === false);
                      
                      // Filter by search query
                      const searchMatch = !psychologistSearchQuery || 
                        p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                        p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                        p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                        p.license_number?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                      
                      return statusMatch && searchMatch;
                    }).length} of {allPsychologists.length} psychologists
                  </div>
                </div>
                {loadingPsychologists ? (
                  <div className="flex justify-center items-center h-64">
                    <Brain className="w-8 h-8 animate-pulse text-blue-600" />
                  </div>
                ) : (
                  <div className="space-y-4">
                    {/* Table */}
                    <div className="overflow-x-auto border rounded-lg">
                      <table className="w-full">
                        <thead className="bg-gray-50 border-b">
                          <tr>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Name</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Email</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Specialization</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Rating</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Approval</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Platform Access</th>
                            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allPsychologists
                            .filter(p => {
                              // Filter by status
                              const statusMatch = 
                                psychologistFilterStatus === 'all' ? true :
                                psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                                (p.is_active === false);
                              
                              // Filter by search query
                              const searchMatch = !psychologistSearchQuery || 
                                p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                              
                              return statusMatch && searchMatch;
                            })
                            .slice((psychologistPage - 1) * psychologistsPerPage, psychologistPage * psychologistsPerPage)
                            .map((psychologist) => (
                              <tr key={psychologist.id} className="border-b hover:bg-gray-50">
                                <td className="px-4 py-3 text-sm font-medium text-gray-900">{psychologist.name}<PsychologistPublicLink page={publicPages[psychologist.id] || null} /></td>
                                <td className="px-4 py-3 text-sm text-gray-600">{psychologist.email}</td>
                                <td className="px-4 py-3 text-sm text-gray-600">{psychologist.specialization || 'N/A'}</td>
                                <td className="px-4 py-3 text-sm text-gray-600">
                                  {psychologist.average_rating ? psychologist.average_rating.toFixed(1) + ' ⭐' : 'No ratings'}
                                </td>
                                <td className="px-4 py-3">
                                  <span className={`px-2 py-1 text-xs rounded-full ${
                                    psychologist.approval_status === 'approved' ? 'bg-green-100 text-green-800' :
                                    psychologist.approval_status === 'rejected' ? 'bg-red-100 text-red-800' :
                                    'bg-orange-100 text-orange-800'
                                  }`}>
                                    {psychologist.approval_status}
                                  </span>
                                </td>
                                <td className="px-4 py-3">
                                  <span className={`px-2 py-1 text-xs rounded-full ${
                                    psychologist.is_active !== false ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
                                  }`}>
                                    {psychologist.is_active !== false ? '✓ Active' : '✕ Deactivated'}
                                  </span>
                                </td>
                                <td className="px-4 py-3"><AccessSummary access={psychologist.platform_access} /><Link className="text-purple-700 underline" to="/admin/psychologist-plans">Psychologist Plans</Link></td>
                                <td className="px-4 py-3">
                                  <div className="flex gap-2 justify-center">
                                    <Button
                                      variant={psychologist.is_active !== false ? "destructive" : "default"}
                                      size="sm"
                                      onClick={() => handleToggleActivation(psychologist.id, psychologist.is_active !== false)}
                                      className={psychologist.is_active !== false ? "" : "bg-green-600 hover:bg-green-700"}
                                    >
                                      {psychologist.is_active !== false ? 'Deactivate' : 'Activate'}
                                    </Button>
                                    <Button
                                      variant="outline"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedPsychologist(psychologist);
                                        setShowPsychologistDetailModal(true);
                                      }}
                                    >
                                      View
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          {allPsychologists.filter(p => {
                            const statusMatch = 
                              psychologistFilterStatus === 'all' ? true :
                              psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                              (p.is_active === false);
                            const searchMatch = !psychologistSearchQuery || 
                              p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                            return statusMatch && searchMatch;
                          }).length === 0 && (
                            <tr>
                              <td colSpan="8" className="text-center py-12">
                                <div className="text-gray-400 mb-4">
                                  <Brain className="w-16 h-16 mx-auto opacity-20" />
                                </div>
                                <h3 className="text-lg font-semibold text-gray-600 mb-2">No psychologists found</h3>
                                <p className="text-gray-500">
                                  {psychologistSearchQuery 
                                    ? `No results for "${psychologistSearchQuery}"`
                                    : `No ${psychologistFilterStatus === 'active' ? 'active' : 'deactivated'} psychologists`
                                  }
                                </p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    
                    {/* Pagination */}
                    {allPsychologists.filter(p => {
                      const statusMatch = 
                        psychologistFilterStatus === 'all' ? true :
                        psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                        (p.is_active === false);
                      const searchMatch = !psychologistSearchQuery || 
                        p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                        p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                        p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                      return statusMatch && searchMatch;
                    }).length > psychologistsPerPage && (
                      <div className="flex justify-between items-center">
                        <div className="text-sm text-gray-600">
                          Showing {((psychologistPage - 1) * psychologistsPerPage) + 1} to {Math.min(psychologistPage * psychologistsPerPage, allPsychologists.filter(p => {
                            const statusMatch = 
                              psychologistFilterStatus === 'all' ? true :
                              psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                              (p.is_active === false);
                            const searchMatch = !psychologistSearchQuery || 
                              p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                            return statusMatch && searchMatch;
                          }).length)} of {allPsychologists.filter(p => {
                            const statusMatch = 
                              psychologistFilterStatus === 'all' ? true :
                              psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                              (p.is_active === false);
                            const searchMatch = !psychologistSearchQuery || 
                              p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                              p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                            return statusMatch && searchMatch;
                          }).length} psychologists
                        </div>
                        <div className="flex gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setPsychologistPage(psychologistPage - 1)}
                            disabled={psychologistPage === 1}
                          >
                            Previous
                          </Button>
                          <span className="px-4 py-2 text-sm">
                            Page {psychologistPage} of {Math.ceil(allPsychologists.filter(p => {
                              const statusMatch = 
                                psychologistFilterStatus === 'all' ? true :
                                psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                                (p.is_active === false);
                              const searchMatch = !psychologistSearchQuery || 
                                p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                              return statusMatch && searchMatch;
                            }).length / psychologistsPerPage)}
                          </span>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => setPsychologistPage(psychologistPage + 1)}
                            disabled={psychologistPage >= Math.ceil(allPsychologists.filter(p => {
                              const statusMatch = 
                                psychologistFilterStatus === 'all' ? true :
                                psychologistFilterStatus === 'active' ? (p.is_active !== false) :
                                (p.is_active === false);
                              const searchMatch = !psychologistSearchQuery || 
                                p.name?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.email?.toLowerCase().includes(psychologistSearchQuery.toLowerCase()) ||
                                p.specialization?.toLowerCase().includes(psychologistSearchQuery.toLowerCase());
                              return statusMatch && searchMatch;
                            }).length / psychologistsPerPage)}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="approval" data-testid="approval-content">
            <Card>
              <CardHeader>
                <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  Psychologist Approval Queue
                </CardTitle>
                <p className="text-sm text-gray-600 mt-2">
                  Review and approve/reject psychologist applications
                </p>
              </CardHeader>
              <CardContent>
                {/* Search Bar */}
                <div className="mb-6">
                  <Input
                    type="text"
                    placeholder="Search by name, email, specialization..."
                    value={pendingSearchQuery}
                    onChange={(e) => setPendingSearchQuery(e.target.value)}
                    className="max-w-md"
                  />
                </div>
                
                {loadingPsychologists ? (
                  <div className="flex justify-center items-center h-64">
                    <Brain className="w-8 h-8 animate-pulse text-blue-600" />
                  </div>
                ) : pendingPsychologists.filter(p => 
                    !pendingSearchQuery || 
                    p.name?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                    p.email?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                    p.proforma?.specialization?.toLowerCase().includes(pendingSearchQuery.toLowerCase())
                  ).length === 0 ? (
                  <div className="text-center py-12">
                    <CheckCircle className="w-16 h-16 mx-auto text-green-500 mb-4" />
                    <p className="text-gray-600">
                      {pendingSearchQuery ? `No results for "${pendingSearchQuery}"` : 'No pending psychologist approvals'}
                    </p>
                  </div>
                ) : (
                  <>
                    {/* Table */}
                    <div className="overflow-x-auto border rounded-lg">
                      <table className="w-full">
                        <thead className="bg-gray-50 border-b">
                          <tr>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Photo</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Name</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Email</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Specialization</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Experience</th>
                            <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Registration</th>
                            <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pendingPsychologists
                            .filter(p => 
                              !pendingSearchQuery || 
                              p.name?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                              p.email?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                              p.proforma?.specialization?.toLowerCase().includes(pendingSearchQuery.toLowerCase())
                            )
                            .slice((pendingApprovalPage - 1) * pendingApprovalPerPage, pendingApprovalPage * pendingApprovalPerPage)
                            .map((psychologist) => (
                              <tr key={psychologist.id} className="border-b hover:bg-gray-50">
                                <td className="px-4 py-3">
                                  {psychologist.proforma?.photo_url ? (
                                    <img 
                                      src={`${API}${psychologist.proforma.photo_url}`} 
                                      alt={psychologist.name}
                                      className="w-12 h-12 rounded-full object-cover border-2 border-blue-200"
                                    />
                                  ) : (
                                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                                      <Brain className="w-6 h-6 text-blue-600" />
                                    </div>
                                  )}
                                </td>
                                <td className="px-4 py-3 text-sm font-medium text-gray-900">{psychologist.name}<PsychologistPublicLink page={publicPages[psychologist.id] || null} /></td>
                                <td className="px-4 py-3 text-sm text-gray-600">{psychologist.email}</td>
                                <td className="px-4 py-3 text-sm text-gray-600">
                                  {psychologist.proforma?.specialization || 'N/A'}
                                </td>
                                <td className="px-4 py-3 text-sm text-gray-600">
                                  {psychologist.proforma?.experience_years ? `${psychologist.proforma.experience_years} years` : 'N/A'}
                                </td>
                                <td className="px-4 py-3 text-sm text-gray-600">
                                  {psychologist.registration_number || 'N/A'}
                                </td>
                                <td className="px-4 py-3">
                                  <div className="flex gap-2 justify-center">
                                    <Button
                                      onClick={() => {
                                        setSelectedPsychologist(psychologist);
                                        setShowPsychologistDetailModal(true);
                                      }}
                                      variant="outline"
                                      size="sm"
                                    >
                                      View
                                    </Button>
                                    <Button
                                      onClick={() => approvePsychologist(psychologist.id)}
                                      disabled={approvingPsychologist}
                                      className="bg-green-600 hover:bg-green-700"
                                      size="sm"
                                    >
                                      <CheckCircle className="w-4 h-4 mr-1" />
                                      Approve
                                    </Button>
                                    <Button
                                      onClick={() => rejectPsychologist(psychologist.id)}
                                      disabled={approvingPsychologist}
                                      variant="destructive"
                                      size="sm"
                                    >
                                      <Trash2 className="w-4 h-4 mr-1" />
                                      Reject
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    
                    {/* Pagination */}
                    <Pagination
                      currentPage={pendingApprovalPage}
                      totalItems={pendingPsychologists.filter(p => 
                        !pendingSearchQuery || 
                        p.name?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                        p.email?.toLowerCase().includes(pendingSearchQuery.toLowerCase()) ||
                        p.proforma?.specialization?.toLowerCase().includes(pendingSearchQuery.toLowerCase())
                      ).length}
                      itemsPerPage={pendingApprovalPerPage}
                      onPageChange={setPendingApprovalPage}
                      onItemsPerPageChange={() => {}}
                      showItemsPerPage={false}
                    />
                  </>
                )}
              </CardContent>
            </Card>
          </TabsContent>
            </Tabs>
          </TabsContent>


          <TabsContent value="report-prompts" data-testid="report-prompts-content">
            <ReportPromptsManager 
              showSuccess={showSuccess}
              showError={showError}
              showInfo={showInfo}
            />
          </TabsContent>

          <TabsContent value="settings" data-testid="settings-content">
              <FreeAccessSettings />
            {settings && (
              <div className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Phase Timers</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <Label>Phase 2 Timer (seconds)</Label>
                      <Input
                        type="number"
                        value={settings.phase2_timer}
                        onChange={(e) => setSettings({ ...settings, phase2_timer: parseInt(e.target.value) })}
                      />
                    </div>
                    <div>
                      <Label>Phase 3 Timer Per Response (seconds)</Label>
                      <Input
                        type="number"
                        value={settings.phase3_timer_per_word}
                        onChange={(e) => setSettings({ ...settings, phase3_timer_per_word: parseInt(e.target.value) })}
                      />
                    </div>
                    <div>
                      <Label>Phase 4 Total Timer (seconds)</Label>
                      <Input
                        type="number"
                        value={settings.phase4_timer_total}
                        onChange={(e) => setSettings({ ...settings, phase4_timer_total: parseInt(e.target.value) })}
                      />
                    </div>
                    <Button onClick={() => updateSettings({ 
                      phase2_timer: settings.phase2_timer, 
                      phase3_timer_per_word: settings.phase3_timer_per_word, 
                      phase4_timer_total: settings.phase4_timer_total 
                    })}>
                      Save Timers
                    </Button>
                  </CardContent>
                </Card>

                <Card data-testid="client-text-correction-setting">
                  <CardHeader>
                    <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Client Text Correction</CardTitle>
                    <p className="text-sm text-gray-500 mt-2">When enabled, Phase 1, Phase 3 and Phase 4 provide conservative spelling correction support while preserving the client's original wording.</p>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input type="checkbox" data-testid="client-text-correction-toggle"
                        checked={settings.client_text_correction_enabled === true}
                        onChange={(e) => setSettings({ ...settings, client_text_correction_enabled: e.target.checked })} />
                      <span>{settings.client_text_correction_enabled ? 'Enabled' : 'Disabled'}</span>
                    </label>
                    <Button data-testid="save-client-text-correction"
                      onClick={() => updateSettings({ client_text_correction_enabled: settings.client_text_correction_enabled === true })}>
                      Save Text Correction Setting
                    </Button>
                  </CardContent>
                </Card>

                {/* Analysis Validity Configuration */}
                {adminSettings && (
                  <Card>
                    <CardHeader>
                      <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Analysis Validity Period</CardTitle>
                      <p className="text-sm text-gray-500 mt-2">
                        Configure how long a completed analysis remains valid before clients must retake it.
                      </p>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      <fieldset className="space-y-3">
                        <legend className="text-sm font-medium">Analysis Validity</legend>
                        <label className="flex items-center gap-2">
                          <input type="radio" name="analysis-validity-mode"
                            checked={adminSettings.analysis_always_valid === true}
                            onChange={() => setAdminSettings({ ...adminSettings, analysis_always_valid: true })} />
                          <span>Analysis Always Valid</span>
                        </label>
                        <label className="flex items-center gap-2">
                          <input type="radio" name="analysis-validity-mode"
                            checked={adminSettings.analysis_always_valid !== true}
                            onChange={() => setAdminSettings({ ...adminSettings, analysis_always_valid: false })} />
                          <span>Apply Validity Period</span>
                        </label>
                      </fieldset>
                      <p className="text-sm font-semibold text-blue-700">
                        Current setting: {savedValiditySettings?.analysis_always_valid
                          ? 'ALWAYS VALID — completed analyses never expire.'
                          : `VALID FOR ${savedValiditySettings?.assessment_validity_days || 90} DAYS — validity is calculated from the original analysis completion date.`}
                      </p>
                      <div>
                        <Label>Analysis Validity Days (1-365)</Label>
                        <Input
                          type="number"
                          min="1"
                          max="365"
                          disabled={adminSettings.analysis_always_valid === true}
                          value={adminSettings.assessment_validity_days || 90}
                          onChange={(e) => {
                            const value = parseInt(e.target.value);
                            if (value >= 1 && value <= 365) {
                              setAdminSettings({ ...adminSettings, assessment_validity_days: value });
                            }
                          }}
                          className="max-w-xs"
                        />
                        <p className="text-xs text-gray-500 mt-2">
                          Current setting: <span className="font-semibold text-blue-600">{adminSettings.assessment_validity_days || 90} days</span>
                        </p>
                        <p className="text-xs text-gray-500 mt-1">
                          {adminSettings.analysis_always_valid
                            ? 'All completed analyses remain valid indefinitely, including analyses completed before this setting was enabled.'
                            : 'Completed analyses remain valid for the configured number of days from their original completion date.'}
                        </p>
                      </div>
                      <Button 
                        onClick={() => updateAdminSettings({ 
                          analysis_always_valid: adminSettings.analysis_always_valid === true,
                          assessment_validity_days: adminSettings.assessment_validity_days 
                        })}
                        className="w-full sm:w-auto"
                      >
                        Save Validity Setting
                      </Button>
                    </CardContent>
                  </Card>
                )}


                {adminSettings && (
                  <Card>
                    <CardHeader>
                      <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Analysis Visibility for Psychologists</CardTitle>
                      <p className="text-xs text-gray-500 mt-1">Toggle which Analysis psychologists can see and generate. Disabled Analysis is hidden from the session view and blocked at the API level (403).</p>
                    </CardHeader>
                    <CardContent className="space-y-3">
                      <div className="flex items-center justify-end gap-2 pb-2 border-b border-gray-100 flex-wrap">
                        <Button
                          size="sm"
                          variant="outline"
                          data-testid="report-vis-preset-individual"
                          onClick={() => {
                            const on = ['report1','report2','report3','report4'];
                            const all = ['report1','report2','report3','report4','ai_summary','metaphorical_portrait','developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns','book_recommendations','movie_recommendations','custom_reports','ask_buddy'];
                            const map = Object.fromEntries(all.map(k => [k, on.includes(k)]));
                            setAdminSettings({ ...adminSettings, report_visibility: map });
                          }}
                        >
                          Individual only
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          data-testid="report-vis-preset-ai"
                          onClick={() => {
                            const on = ['ai_summary','metaphorical_portrait'];
                            const all = ['report1','report2','report3','report4','ai_summary','metaphorical_portrait','developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns','book_recommendations','movie_recommendations','custom_reports','ask_buddy'];
                            const map = Object.fromEntries(all.map(k => [k, on.includes(k)]));
                            setAdminSettings({ ...adminSettings, report_visibility: map });
                          }}
                        >
                          AI Analysis only
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          data-testid="report-vis-preset-features"
                          onClick={() => {
                            const on = ['developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns'];
                            const all = ['report1','report2','report3','report4','ai_summary','metaphorical_portrait','developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns','book_recommendations','movie_recommendations','custom_reports','ask_buddy'];
                            const map = Object.fromEntries(all.map(k => [k, on.includes(k)]));
                            setAdminSettings({ ...adminSettings, report_visibility: map });
                          }}
                        >
                          Features only
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          data-testid="report-vis-enable-all"
                          onClick={() => {
                            const registry_keys = ['report1','report2','report3','report4','ai_summary','metaphorical_portrait','developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns','book_recommendations','movie_recommendations','custom_reports','ask_buddy'];
                            const all_on = Object.fromEntries(registry_keys.map(k => [k, true]));
                            setAdminSettings({ ...adminSettings, report_visibility: all_on });
                          }}
                        >
                          Enable All
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          className="text-red-600 border-red-300 hover:bg-red-50"
                          data-testid="report-vis-disable-all"
                          onClick={() => {
                            const registry_keys = ['report1','report2','report3','report4','ai_summary','metaphorical_portrait','developmental_ecological_cultural','research_framework_synthesis','apa_case_parallels','thematic_threads','persistent_patterns','book_recommendations','movie_recommendations','custom_reports','ask_buddy'];
                            const all_off = Object.fromEntries(registry_keys.map(k => [k, false]));
                            setAdminSettings({ ...adminSettings, report_visibility: all_off });
                          }}
                        >
                          Disable All
                        </Button>
                      </div>
                      {(() => {
                        const registry = [
                          { key: 'report1', label: 'Exploring Client Feelings', group: 'Individual Analysis' },
                          { key: 'report2', label: 'Emotional Balance Snapshot', group: 'Individual Analysis' },
                          { key: 'report3', label: 'Deep Dive into Inner World', group: 'Individual Analysis' },
                          { key: 'report4', label: 'Strengths and Coping Guide', group: 'Individual Analysis' },
                          { key: 'ai_summary', label: 'Client Synthesis', group: 'AI Analysis' },
                          { key: 'custom_reports', label: 'Custom Analysis', group: 'AI Analysis' },
                          { key: 'metaphorical_portrait', label: 'Metaphorical Client Portrait', group: 'AI Analysis' },
                          { key: 'developmental_ecological_cultural', label: 'Developmental–Ecological–Cultural Integration Analysis', group: 'Research Tab' },
                          { key: 'research_framework_synthesis', label: 'Research Framework Synthesis', group: 'Research Tab' },
                          { key: 'apa_case_parallels', label: 'APA Case Parallels', group: 'Research Tab' },
                          { key: 'thematic_threads', label: 'Thematic Threads Analysis', group: 'Features Tab' },
                          { key: 'persistent_patterns', label: 'Persistent Patterns Spotlight', group: 'Features Tab' },
                          { key: 'book_recommendations', label: 'Book Reflections', group: 'Recommendations' },
                          { key: 'movie_recommendations', label: 'Movie Reflections', group: 'Recommendations' },
                          { key: 'music_recommendations', label: 'Music Reflections', group: 'Recommendations' },
                          
                          { key: 'ask_buddy', label: 'Ask Buddy', group: 'Assistants' },
                        ];
                        const groups = [...new Set(registry.map(r => r.group))];
                        const vis = adminSettings.report_visibility || {};
                        return groups.map(group => (
                          <div key={group} className="space-y-1">
                            <p className="text-xs uppercase tracking-wide font-semibold text-gray-500 mt-2">{group}</p>
                            {registry.filter(r => r.group === group).map(r => (
                              <div key={r.key} className="flex items-center justify-between gap-3 py-1.5 border-b border-gray-100">
                                <label htmlFor={`rv-${r.key}`} className="text-sm text-gray-800 flex-1 cursor-pointer">{r.label}</label>
                                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                                  <input
                                    id={`rv-${r.key}`}
                                    data-testid={`report-vis-toggle-${r.key}`}
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={vis[r.key] !== false}
                                    onChange={(e) => setAdminSettings({
                                      ...adminSettings,
                                      report_visibility: { ...vis, [r.key]: e.target.checked }
                                    })}
                                  />
                                  <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                                </label>
                              </div>
                            ))}
                          </div>
                        ));
                      })()}
                      <Button
                        onClick={() => updateAdminSettings({ report_visibility: adminSettings.report_visibility })}
                        className="w-full sm:w-auto mt-3"
                        data-testid="save-report-visibility-btn"
                      >
                        Save Analysis Visibility
                      </Button>
                    </CardContent>
                  </Card>
                )}





                <Card>
                  <CardHeader>
                    <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Phase 3 Words</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <Label>Number of Words to Show</Label>
                      <Input
                        type="number"
                        min="1"
                        max={wordsText.split(',').map(w => w.trim()).filter(Boolean).length}
                        value={settings.phase3_num_words || 20}
                        onChange={(e) => setSettings({ ...settings, phase3_num_words: parseInt(e.target.value) })}
                      />
                    </div>
                    <div>
                      <Label>Predefined Word List (comma-separated)</Label>
                      <Textarea
                        value={wordsText}
                        onChange={(e) => setWordsText(e.target.value)}
                        placeholder="Family, Friends, Planning, Love..."
                        rows={5}
                      />
                    </div>
                    <Button onClick={() => {
                      const words = wordsText.split(',').map(w => w.trim()).filter(w => w);
                      updateSettings({ 
                        phase3_words: words,
                        phase3_num_words: settings.phase3_num_words || 20
                      });
                    }}>
                      Save Phase 3 Configuration
                    </Button>
                  </CardContent>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Phase 4 Configuration</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <Label>Number of Favorite Things (5-10)</Label>
                      <Input
                        type="number"
                        min="5"
                        max="10"
                        value={settings.phase4_num_items || 10}
                        onChange={(e) => setSettings({ ...settings, phase4_num_items: parseInt(e.target.value) })}
                      />
                    </div>
                    <div>
                      <Label>Words Per Item (1-5)</Label>
                      <Input
                        type="number"
                        min="1"
                        max="5"
                        value={settings.phase4_words_per_item || 5}
                        onChange={(e) => setSettings({ ...settings, phase4_words_per_item: parseInt(e.target.value) })}
                      />
                    </div>
                    <div>
                      <Label>Learning & Coping Mechanisms (comma-separated)</Label>
                      <Textarea
                        value={settings.phase4_coping_mechanisms?.map(displayResponseStatus).join(', ') || 'Watching, Listening, Playing, Reading, Socializing, Through Success Stories, Family Members, Petting, Praying, Visiting Native Place, Travelling, Singing, Eating, Writing, Drawing, Exercising, Drugs, Romancing, Sleeping, Love, Undisclosed, System Time Expired'}
                        onChange={(e) => setSettings({ ...settings, phase4_coping_mechanisms: e.target.value.split(',').map(m => m.trim()).filter(m => m) })}
                        placeholder="Watching, Listening, Playing, Reading..."
                        rows={4}
                      />
                    </div>
                    <div>
                      <Label>Thematic Domains (comma-separated)</Label>
                      <Textarea
                        value={settings.phase4_thematic_domains?.map(displayResponseStatus).join(', ') || 'Family, Friends, Love, Patriotism, Personality Development, Horror, Suspense, Planning, Fiction, Fantasy, Nature, Memories, Hobbies, Philosophy, Spirituality, Romance, Undisclosed, System Time Expired'}
                        onChange={(e) => setSettings({ ...settings, phase4_thematic_domains: e.target.value.split(',').map(t => t.trim()).filter(t => t) })}
                        placeholder="Family, Friends, Love, Patriotism..."
                        rows={4}
                      />
                    </div>
                    <Button onClick={() => updateSettings({ 
                      phase4_num_items: settings.phase4_num_items || 10,
                      phase4_words_per_item: settings.phase4_words_per_item || 5,
                      phase4_coping_mechanisms: settings.phase4_coping_mechanisms || [],
                      phase4_thematic_domains: settings.phase4_thematic_domains || []
                    })}>
                      Save Phase 4 Configuration
                    </Button>
                  </CardContent>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Moral Story (Phase 2)</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <Label>Story Content</Label>
                      <Textarea
                        value={moralStoryContent}
                        onChange={(e) => setMoralStoryContent(e.target.value)}
                        placeholder="Enter the moral story content used in Phase 2..."
                        rows={15}
                        className="font-serif"
                      />
                      <p className="text-sm text-gray-500 mt-2">
                        This story is displayed to clients in Phase 2 of their analysis.
                      </p>
                    </div>
                    <Button 
                      onClick={saveMoralStory}
                      disabled={savingMoralStory}
                      style={{ background: '#2563EB' }}
                    >
                      {savingMoralStory ? 'Saving...' : 'Save Moral Story'}
                    </Button>
                  </CardContent>
                </Card>
              </div>
            )}
          </TabsContent>

          <TabsContent value="account" data-testid="account-content">
            <div className="space-y-6">
              {/* Change Password Card */}
              <Card>
                <CardHeader>
                  <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Change Password</CardTitle>
                </CardHeader>
                <CardContent>
                  <form onSubmit={handleChangePassword} className="space-y-4 max-w-md">
                    <div>
                      <Label htmlFor="current-password">Current Password</Label>
                      <Input
                        id="current-password"
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                        data-testid="current-password-input"
                      />
                    </div>
                    <div>
                      <Label htmlFor="new-password">New Password</Label>
                      <Input
                        id="new-password"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={6}
                        data-testid="new-password-input"
                      />
                    </div>
                    <div>
                      <Label htmlFor="confirm-password">Confirm New Password</Label>
                      <Input
                        id="confirm-password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength={6}
                        data-testid="confirm-password-input"
                      />
                    </div>
                    <Button 
                      type="submit" 
                      disabled={changingPassword}
                      data-testid="change-password-btn"
                      style={{ background: '#2563EB' }}
                    >
                      {changingPassword ? 'Changing Password...' : 'Change Password'}
                    </Button>
                  </form>
                </CardContent>
              </Card>
              
              {/* Account Settings Component */}
              <AccountSettings 
                onLogout={logout} 
                showNotification={(type, message) => {
                  if (type === 'success') showSuccess(message);
                  else if (type === 'error') showError(message);
                  else if (type === 'info') showInfo(message);
                }}
              />
            </div>
          </TabsContent>

          <TabsContent value="users" data-testid="users-content">
            <div className="space-y-6">
              {/* Clients Section */}
              <Card>
                <CardHeader>
                  <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    Clients ({clients.length})
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {/* Search Bar */}
                  <div className="mb-4">
                    <Input
                      type="text"
                      placeholder="Search clients by name or email..."
                      value={clientsSearchQuery}
                      onChange={(e) => setClientsSearchQuery(e.target.value)}
                      className="max-w-md"
                    />
                  </div>
                  
                  {clients.filter(c =>
                    !clientsSearchQuery ||
                    c.name?.toLowerCase().includes(clientsSearchQuery.toLowerCase()) ||
                    c.email?.toLowerCase().includes(clientsSearchQuery.toLowerCase())
                  ).length === 0 ? (
                    <div className="text-center py-12">
                      <Users className="w-16 h-16 mx-auto text-gray-300 mb-4" />
                      <p className="text-gray-500">
                        {clientsSearchQuery ? `No results for "${clientsSearchQuery}"` : 'No clients'}
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Table */}
                      <div className="overflow-x-auto border rounded-lg">
                        <table className="w-full">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Name</th>
                              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Email</th>
                              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {clients
                              .filter(c =>
                                !clientsSearchQuery ||
                                c.name?.toLowerCase().includes(clientsSearchQuery.toLowerCase()) ||
                                c.email?.toLowerCase().includes(clientsSearchQuery.toLowerCase())
                              )
                              .slice((clientsPage - 1) * clientsPerPage, clientsPage * clientsPerPage)
                              .map((u, idx) => (
                                <tr key={u.id} className="border-b hover:bg-gray-50" data-testid={`client-row-${idx}`}>
                                  <td className="px-4 py-3 text-sm font-medium text-gray-900">{u.name}</td>
                                  <td className="px-4 py-3 text-sm text-gray-600">{u.email}</td>
                                  <td className="px-4 py-3">
                                    <div className="flex gap-2 justify-center">
                                      <Button 
                                        variant="outline" 
                                        size="sm" 
                                        onClick={() => resetUserPassword(u.id, u.name)} 
                                        data-testid={`reset-client-pwd-${idx}`}
                                        title="Reset password"
                                      >
                                        <Key className="w-4 h-4 mr-1" />
                                        Reset
                                      </Button>
                                      <Button 
                                        variant="destructive" 
                                        size="sm" 
                                        onClick={() => deleteUser(u.id)} 
                                        data-testid={`delete-client-btn-${idx}`}
                                      >
                                        <Trash2 className="w-4 h-4 mr-1" />
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      
                      {/* Pagination */}
                      <Pagination
                        currentPage={clientsPage}
                        totalItems={clients.filter(c =>
                          !clientsSearchQuery ||
                          c.name?.toLowerCase().includes(clientsSearchQuery.toLowerCase()) ||
                          c.email?.toLowerCase().includes(clientsSearchQuery.toLowerCase())
                        ).length}
                        itemsPerPage={clientsPerPage}
                        onPageChange={setClientsPage}
                        onItemsPerPageChange={() => {}}
                        showItemsPerPage={false}
                      />
                    </>
                  )}
                </CardContent>
              </Card>

              {/* Psychologists Section */}
              <Card>
                <CardHeader>
                  <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    Psychologists ({psychologists.length})
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {/* Search Bar */}
                  <div className="mb-4">
                    <Input
                      type="text"
                      placeholder="Search psychologists by name or email..."
                      value={psychologistsUserSearchQuery}
                      onChange={(e) => setPsychologistsUserSearchQuery(e.target.value)}
                      className="max-w-md"
                    />
                  </div>
                  
                  {psychologists.filter(p =>
                    !psychologistsUserSearchQuery ||
                    p.name?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase()) ||
                    p.email?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase())
                  ).length === 0 ? (
                    <div className="text-center py-12">
                      <Brain className="w-16 h-16 mx-auto text-gray-300 mb-4" />
                      <p className="text-gray-500">
                        {psychologistsUserSearchQuery ? `No results for "${psychologistsUserSearchQuery}"` : 'No psychologists'}
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Table */}
                      <div className="overflow-x-auto border rounded-lg">
                        <table className="w-full">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Name</th>
                              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Email</th>
                              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {psychologists
                              .filter(p =>
                                !psychologistsUserSearchQuery ||
                                p.name?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase()) ||
                                p.email?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase())
                              )
                              .slice((psychologistsUserPage - 1) * psychologistsUserPerPage, psychologistsUserPage * psychologistsUserPerPage)
                              .map((u, idx) => (
                                <tr key={u.id} className="border-b hover:bg-gray-50" data-testid={`psychologist-row-${idx}`}>
                                  <td className="px-4 py-3 text-sm font-medium text-gray-900">{withDoctorTitle(u.name)}</td>
                                  <td className="px-4 py-3 text-sm text-gray-600">{u.email}</td>
                                  <td className="px-4 py-3">
                                    <div className="flex gap-2 justify-center">
                                      <Button 
                                        variant="outline" 
                                        size="sm" 
                                        onClick={() => resetUserPassword(u.id, u.name)} 
                                        data-testid={`reset-psych-pwd-${idx}`}
                                        title="Reset password"
                                      >
                                        <Key className="w-4 h-4 mr-1" />
                                        Reset
                                      </Button>
                                      <Button 
                                        variant="destructive" 
                                        size="sm" 
                                        onClick={() => deleteUser(u.id)} 
                                        data-testid={`delete-psych-btn-${idx}`}
                                      >
                                        <Trash2 className="w-4 h-4 mr-1" />
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      
                      {/* Pagination */}
                      <Pagination
                        currentPage={psychologistsUserPage}
                        totalItems={psychologists.filter(p =>
                          !psychologistsUserSearchQuery ||
                          p.name?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase()) ||
                          p.email?.toLowerCase().includes(psychologistsUserSearchQuery.toLowerCase())
                        ).length}
                        itemsPerPage={psychologistsUserPerPage}
                        onPageChange={setPsychologistsUserPage}
                        onItemsPerPageChange={() => {}}
                        showItemsPerPage={false}
                      />
                    </>
                  )}
                </CardContent>
              </Card>
            </div>
          </TabsContent>

          {/* Q&A Management Tab */}
          <TabsContent value="qa" data-testid="qa-content">
            <Card>
              <CardHeader>
                <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>Client-Psychologist Q&A Management</CardTitle>
              </CardHeader>
              <CardContent>
                {/* Search Bar */}
                <div className="mb-6">
                  <Label htmlFor="qa-search" className="text-sm font-medium mb-2 block">
                    Search by Client, Psychologist, or Question
                  </Label>
                  <Input
                    id="qa-search"
                    type="text"
                    placeholder="Search Q&A threads..."
                    value={qaSearchTerm}
                    onChange={(e) => {
                      setQaSearchTerm(e.target.value);
                      setQaPage(1);
                    }}
                    className="w-full"
                    data-testid="qa-search-input"
                  />
                </div>

                {loadingQaThreads ? (
                  <div className="flex justify-center items-center h-64">
                    <p className="text-gray-500">Loading Q&A threads...</p>
                  </div>
                ) : qaThreads.length === 0 ? (
                  <p className="text-gray-500 text-center py-8">No Q&A threads found</p>
                ) : (
                  <>
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300">
                        <thead className="bg-blue-50">
                          <tr>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client Name</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Psychologist Name</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Question</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Status</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Messages</th>
                            <th className="border border-gray-300 px-4 py-3 text-center font-semibold text-gray-700">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            // Filter Q&A threads
                            const filteredThreads = qaThreads.filter(thread => {
                              const searchLower = qaSearchTerm.toLowerCase();
                              return (
                                thread.client_name?.toLowerCase().includes(searchLower) ||
                                thread.psychologist_name?.toLowerCase().includes(searchLower) ||
                                thread.subject?.toLowerCase().includes(searchLower) ||
                                thread.first_question?.toLowerCase().includes(searchLower)
                              );
                            });

                            const paginatedThreads = filteredThreads.slice(
                              (qaPage - 1) * itemsPerPage,
                              qaPage * itemsPerPage
                            );

                            return paginatedThreads.map((thread, idx) => (
                              <tr key={thread.id} className="hover:bg-gray-50">
                                <td className="border border-gray-300 px-4 py-3 text-sm font-semibold">
                                  {thread.client_name || 'Unknown'}
                                </td>
                                <td className="border border-gray-300 px-4 py-3 text-sm">
                                  {thread.psychologist_name || 'Not assigned'}
                                </td>
                                <td className="border border-gray-300 px-4 py-3 text-sm">
                                  <div className="max-w-xs">
                                    <p className="font-semibold mb-1">{thread.subject}</p>
                                    <p className="text-xs text-gray-600">{thread.first_question}</p>
                                  </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-3 text-sm">
                                  {thread.status === 'open' && (
                                    <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full">
                                      Open
                                    </span>
                                  )}
                                  {thread.status === 'answered' && (
                                    <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                                      Answered
                                    </span>
                                  )}
                                  {thread.status === 'resolved' && (
                                    <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs font-medium rounded-full">
                                      Resolved
                                    </span>
                                  )}
                                </td>
                                <td className="border border-gray-300 px-4 py-3 text-sm text-center">
                                  <span className="font-medium">{thread.message_count}</span>
                                </td>
                                <td className="border border-gray-300 px-4 py-3">
                                  <div className="flex justify-center space-x-2">
                                    {/* Open button - only show for answered/resolved threads */}
                                    {thread.status !== 'open' && (
                                      <Button
                                        onClick={() => {
                                          setViewingQaThread(thread);
                                          setShowQaThreadModal(true);
                                        }}
                                        size="sm"
                                        variant="outline"
                                        title="Open thread"
                                        className="border-blue-500 text-blue-600 hover:bg-blue-50"
                                      >
                                        👁️ Open
                                      </Button>
                                    )}
                                    {/* Edit button - only show for open/answered threads (not resolved) */}
                                    {thread.status !== 'resolved' && (
                                      <Button
                                        onClick={() => {
                                          setViewingQaThread(thread);
                                          setShowQaThreadModal(true);
                                        }}
                                        size="sm"
                                        variant="outline"
                                        title="Edit/Reply to thread"
                                        className="border-green-500 text-green-600 hover:bg-green-50"
                                      >
                                        ✏️ Edit
                                      </Button>
                                    )}
                                    <Button
                                      onClick={() => downloadQaPdf(thread.id)}
                                      size="sm"
                                      variant="outline"
                                      title="Download PDF"
                                    >
                                      📄 Download
                                    </Button>
                                    {thread.status !== 'resolved' && (
                                      <Button
                                        onClick={() => closeQaThread(thread.id)}
                                        size="sm"
                                        variant="secondary"
                                        title="Close Chat"
                                        className="bg-blue-500 hover:bg-blue-600 text-white"
                                      >
                                        🔒 Close
                                      </Button>
                                    )}
                                    <Button
                                      onClick={() => deleteQaThread(thread.id)}
                                      size="sm"
                                      variant="destructive"
                                      title="Delete"
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ));
                          })()}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    {(() => {
                      const filteredThreads = qaThreads.filter(thread => {
                        const searchLower = qaSearchTerm.toLowerCase();
                        return (
                          thread.client_name?.toLowerCase().includes(searchLower) ||
                          thread.psychologist_name?.toLowerCase().includes(searchLower) ||
                          thread.subject?.toLowerCase().includes(searchLower) ||
                          thread.first_question?.toLowerCase().includes(searchLower)
                        );
                      });

                      const totalPages = Math.ceil(filteredThreads.length / itemsPerPage);

                      return filteredThreads.length > itemsPerPage && (
                        <div className="flex items-center justify-between border-t pt-4 mt-4">
                          <Button
                            onClick={() => setQaPage(Math.max(1, qaPage - 1))}
                            disabled={qaPage === 1}
                            variant="outline"
                            size="sm"
                          >
                            Previous
                          </Button>
                          <span className="text-sm text-gray-600">
                            Page {qaPage} of {totalPages} ({filteredThreads.length} {qaSearchTerm ? 'filtered' : 'total'} threads)
                          </span>
                          <Button
                            onClick={() => setQaPage(Math.min(totalPages, qaPage + 1))}
                            disabled={qaPage === totalPages}
                            variant="outline"
                            size="sm"
                          >
                            Next
                          </Button>
                        </div>
                      );
                    })()}
                  </>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="feedback" data-testid="feedback-content">
            <Card>
              <CardHeader>
                <CardTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>User Feedback</CardTitle>
              </CardHeader>
              <CardContent>
                {feedback.length === 0 ? (
                  <p className="text-gray-500 text-center py-8">No feedback received yet</p>
                ) : (
                  <>
                    <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-blue-50">
                        <tr>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">User</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Role</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Category</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Rating</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Message</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Date</th>
                          <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Status</th>
                          <th className="border border-gray-300 px-4 py-3 text-center font-semibold text-gray-700">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feedback.slice((feedbackPage - 1) * feedbackItemsPerPage, feedbackPage * feedbackItemsPerPage).map((fb, idx) => (
                          <tr key={fb.id} className={`hover:bg-gray-50 ${fb.status === 'unread' ? 'bg-blue-50' : fb.status === 'resolved' ? 'bg-green-50' : ''}`} data-testid={`feedback-row-${idx}`}>
                            <td className="border border-gray-300 px-4 py-3 text-sm font-medium">
                              {fb.user_name}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm capitalize">
                              {fb.user_role}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              <span className="inline-block px-2 py-1 text-xs rounded" style={{ backgroundColor: '#E3F2FD', color: '#1976D2' }}>
                                {fb.category}
                              </span>
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {fb.rating ? '⭐'.repeat(fb.rating) : 'N/A'}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              <div className="max-w-md">
                                {fb.message}
                                {fb.admin_reply && (
                                  <div className="mt-2 pt-2 border-t border-blue-200">
                                    <p className="text-xs text-blue-600 font-semibold mb-1">Admin Reply:</p>
                                    <p className="text-xs text-blue-700">{fb.admin_reply}</p>
                                    <p className="text-xs text-gray-500 mt-1">By {fb.admin_name} • {new Date(fb.admin_reply_at).toLocaleString()}</p>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
                              {new Date(fb.created_at).toLocaleString()}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              <Select value={fb.status} onValueChange={(val) => updateFeedbackStatus(fb.id, val)}>
                                <SelectTrigger className="w-28 h-8 text-xs">
                                  <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="unread">Unread</SelectItem>
                                  <SelectItem value="read">Read</SelectItem>
                                  <SelectItem value="resolved">Resolved</SelectItem>
                                </SelectContent>
                              </Select>
                            </td>
                            <td className="border border-gray-300 px-4 py-3">
                              <div className="flex gap-2 justify-center">
                                <Button 
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    setSelectedFeedback(fb);
                                    setFeedbackReply(fb.admin_reply || '');
                                    setShowFeedbackReplyModal(true);
                                  }}
                                  title="Reply to feedback"
                                  className="border-blue-500 text-blue-600 hover:bg-blue-50"
                                >
                                  💬 Reply
                                </Button>
                                <Button 
                                  variant="destructive" 
                                  size="sm"
                                  onClick={() => handleDeleteFeedbackClick(fb)}
                                  data-testid={`delete-feedback-${idx}`}
                                  title="Delete feedback"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    </div>
                    
                    <Pagination
                      currentPage={feedbackPage}
                      totalItems={feedback.length}
                      itemsPerPage={feedbackItemsPerPage}
                      onPageChange={setFeedbackPage}
                      onItemsPerPageChange={setFeedbackItemsPerPage}
                    />
                  </>
                )}
              </CardContent>
            </Card>
          </TabsContent>




          {/* Payment History Tab */}
          <TabsContent value="payments">
            <Tabs value={paymentsTab} onValueChange={selectPaymentsTab}>
              <TabsList aria-label="Payment History" className="flex flex-wrap h-auto w-full justify-start gap-2 mb-4">
                <TabsTrigger value="history">Historical Client Payments</TabsTrigger>
              </TabsList>
          <TabsContent value="history" data-testid="payments-content">
            <Card>
              <CardHeader>
                <div className="flex flex-col gap-4">
                  <div className="flex flex-row items-center justify-between">
                    <CardTitle>Historical Client Consultation Payments (read-only)</CardTitle>
                    {paymentTotalRecords > 0 && (
                      <span className="text-sm text-gray-500 font-semibold">
                        {paymentTotalRecords} records found
                      </span>
                    )}
                  </div>
                  
                  {/* Status filter chips */}
                  <div className="flex flex-wrap gap-2" data-testid="payment-status-chips">
                    {[
                      { label: 'All', value: '' },
                      { label: 'Paid', value: 'paid' },
                      { label: 'Pending', value: 'pending' },
                      { label: 'Failed', value: 'failed' },
                      { label: 'Waived', value: 'waived' },
                    ].map((chip) => {
                      const active = (paymentSearchQuery || '').trim().toLowerCase() === chip.value;
                      return (
                        <button
                          key={chip.value || 'all'}
                          type="button"
                          onClick={() => {
                            setPaymentSearchQuery(chip.value);
                            clearTimeout(window.paymentSearchTimeout);
                            fetchPaymentHistory(1, chip.value, paymentFromDate, paymentToDate);
                          }}
                          data-testid={`payment-chip-${chip.value || 'all'}`}
                          className={
                            'px-3 py-1 rounded-full text-xs font-medium border transition-colors ' +
                            (active
                              ? 'bg-blue-600 text-white border-blue-600'
                              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50')
                          }
                        >
                          {chip.label}
                        </button>
                      );
                    })}
                  </div>
                  
                  {/* Search and Filter Section */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    {/* Text Search */}
                    <div className="flex-1">
                      <input
                        type="text"
                        placeholder="Search by client, psychologist, status..."
                        value={paymentSearchQuery}
                        onChange={(e) => {
                          setPaymentSearchQuery(e.target.value);
                          // Debounce search - trigger after user stops typing for 500ms
                          clearTimeout(window.paymentSearchTimeout);
                          window.paymentSearchTimeout = setTimeout(() => {
                            fetchPaymentHistory(1, e.target.value, paymentFromDate, paymentToDate);
                          }, 500);
                        }}
                        className="w-full pl-4 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    
                    {/* Date Range Filters */}
                    <div className="flex gap-2 items-center">
                      <label className="text-sm text-gray-600 font-medium whitespace-nowrap">From:</label>
                      <input
                        type="date"
                        value={paymentFromDate}
                        onChange={(e) => {
                          setPaymentFromDate(e.target.value);
                          fetchPaymentHistory(1, paymentSearchQuery, e.target.value, paymentToDate);
                        }}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    
                    <div className="flex gap-2 items-center">
                      <label className="text-sm text-gray-600 font-medium whitespace-nowrap">To:</label>
                      <input
                        type="date"
                        value={paymentToDate}
                        onChange={(e) => {
                          setPaymentToDate(e.target.value);
                          fetchPaymentHistory(1, paymentSearchQuery, paymentFromDate, e.target.value);
                        }}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    
                    {/* Clear Filters Button */}
                    {(paymentSearchQuery || paymentFromDate || paymentToDate) && (
                      <button
                        onClick={() => {
                          setPaymentSearchQuery('');
                          setPaymentFromDate('');
                          setPaymentToDate('');
                          fetchPaymentHistory(1, '', '', '');
                        }}
                        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md text-sm font-medium whitespace-nowrap"
                      >
                        Clear Filters
                      </button>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                {loadingPayments ? (
                  <div className="flex justify-center items-center h-64">
                    <p className="text-gray-500">Loading payment history...</p>
                  </div>
                ) : paymentHistory.length > 0 ? (
                  <>
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300">
                        <thead className="bg-blue-50">
                          <tr>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client Name</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Psychologist Name</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Amount</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Date</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Transaction ID</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Session ID</th>
                            <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentHistory.map((payment, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                <span className="font-medium text-blue-600">
                                  {payment.client_name || 'Unknown Client'}
                                </span>
                                {payment.client_email && (
                                  <div className="text-xs text-gray-500">{payment.client_email}</div>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                <span className="font-medium text-green-600">
                                  {payment.psychologist_name || 'Unknown Psychologist'}
                                </span>
                                {payment.psychologist_email && (
                                  <div className="text-xs text-gray-500">{payment.psychologist_email}</div>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                <span className="flex items-center font-semibold text-green-700">
                                  <IndianRupee className="w-4 h-4 mr-1" />
                                  {payment.amount || '0.00'}
                                </span>
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                {payment.payment_date ? (
                                  <>
                                    <div className="font-medium">
                                      {new Date(payment.payment_date).toLocaleDateString()}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                      {new Date(payment.payment_date).toLocaleTimeString()}
                                    </div>
                                  </>
                                ) : (
                                  <span className="text-gray-400">No date</span>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                {payment.transaction_id ? (
                                  <code className="px-2 py-1 bg-gray-100 rounded text-xs">
                                    {payment.transaction_id}
                                  </code>
                                ) : (
                                  <span className="text-gray-400">No transaction ID</span>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                {payment.session_id ? (
                                  <code className="px-2 py-1 bg-blue-100 rounded text-xs">
                                    {payment.session_id}
                                  </code>
                                ) : (
                                  <span className="text-gray-400">No session ID</span>
                                )}
                              </td>
                              <td className="border border-gray-300 px-4 py-3 text-sm">
                                <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                                  payment.status === 'paid' || payment.status === 'completed'
                                    ? 'bg-green-100 text-green-800'
                                    : payment.status === 'waived'
                                    ? 'bg-purple-100 text-purple-800'
                                    : payment.status === 'pending'
                                    ? 'bg-yellow-100 text-yellow-800'
                                    : payment.status === 'failed'
                                    ? 'bg-red-100 text-red-800'
                                    : payment.status === 'refunded'
                                    ? 'bg-blue-100 text-blue-800'
                                    : 'bg-gray-100 text-gray-800'
                                }`}>
                                  {payment.status ? payment.status.charAt(0).toUpperCase() + payment.status.slice(1) : 'Unknown'}
                                </span>
                                {payment.waiver_reason && (
                                  <div className="mt-1 text-[10px] italic text-gray-500" title={payment.waiver_reason}>
                                    Reason: {payment.waiver_reason.length > 40 ? payment.waiver_reason.slice(0, 40) + '…' : payment.waiver_reason}
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    
                    <div className="mt-4">
                      <Pagination
                        currentPage={paymentCurrentPage}
                        totalItems={paymentTotalRecords}
                        itemsPerPage={paymentsPerPage}
                        onPageChange={(page) => fetchPaymentHistory(page, paymentSearchQuery, paymentFromDate, paymentToDate)}
                        onItemsPerPageChange={(newLimit) => {
                          // Update items per page and refetch
                          setPaymentHistory([]);
                          fetchPaymentHistory(1, paymentSearchQuery, paymentFromDate, paymentToDate);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <div className="text-center py-12">
                    <IndianRupee className="w-16 h-16 mx-auto mb-4 text-gray-400" />
                    <p className="text-gray-600 font-semibold mb-2">No Payment History Found</p>
                    <p className="text-sm text-gray-500">
                      {paymentSearchQuery 
                        ? `No payments match your search "${paymentSearchQuery}"`
                        : 'No payments have been processed yet.'
                      }
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>
            </Tabs>
          </TabsContent>

        </Tabs>
      </div>
      

      {/* Waive Payment Confirmation Dialog (captures optional reason) */}
      <Dialog open={waiveDialogOpen} onOpenChange={(o) => { if (!o) closeWaiveDialog(); }}>
        <DialogContent className="max-w-md" data-testid="waive-payment-dialog">
          <DialogHeader>
            <DialogTitle>Waive Payment?</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            {waiveTarget && (
              <div className="p-3 bg-gray-50 rounded text-sm space-y-1">
                <div><span className="text-gray-500">Client:</span> <span className="font-medium">{waiveTarget.client_name || '—'}</span></div>
                <div><span className="text-gray-500">Psychologist:</span> <span className="font-medium">{waiveTarget.psychologist_name || '—'}</span></div>
                <div><span className="text-gray-500">Fee:</span> <span className="font-semibold">₹{waiveTarget.consultation_fee ?? 0}</span></div>
              </div>
            )}
            <p className="text-sm text-gray-600">
              This will skip the payment step and activate the client session immediately. This action is logged in the audit trail.
            </p>
            <div>
              <Label htmlFor="waive-reason" className="text-sm">Reason for waiver <span className="text-gray-400">(optional)</span></Label>
              <Textarea
                id="waive-reason"
                value={waiveReason}
                onChange={(e) => setWaiveReason(e.target.value)}
                placeholder="e.g. Complimentary session, technical payment issue, sponsored booking…"
                rows={3}
                maxLength={1000}
                className="mt-1"
                disabled={!!waivingConsultationId}
                data-testid="waive-reason-input"
              />
              <p className="text-xs text-gray-400 mt-1">{waiveReason.length}/1000</p>
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={closeWaiveDialog} disabled={!!waivingConsultationId} data-testid="waive-cancel-btn">
              Cancel
            </Button>
            <Button onClick={confirmWaivePayment} disabled={!!waivingConsultationId} data-testid="waive-confirm-btn">
              {waivingConsultationId ? 'Waiving…' : 'Confirm Waiver'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Q&A Thread View Modal */}
      <Dialog open={showQaThreadModal} onOpenChange={setShowQaThreadModal}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Q&A Thread Details
            </DialogTitle>
          </DialogHeader>
          {viewingQaThread && (
            <div className="space-y-6">
              {/* Thread Info */}
              <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="text-sm text-gray-600">Client</p>
                  <p className="font-semibold">{viewingQaThread.client_name}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Psychologist</p>
                  <p className="font-semibold">{viewingQaThread.psychologist_name || 'Not assigned'}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Subject</p>
                  <p className="font-semibold">{viewingQaThread.subject}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Status</p>
                  {viewingQaThread.status === 'open' && (
                    <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full">
                      Open
                    </span>
                  )}
                  {viewingQaThread.status === 'answered' && (
                    <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                      Answered
                    </span>
                  )}
                  {viewingQaThread.status === 'resolved' && (
                    <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs font-medium rounded-full">
                      Resolved
                    </span>
                  )}
                </div>
              </div>
              
              {/* Messages */}
              <div className="space-y-4">
                <h4 className="font-semibold text-lg">Conversation</h4>
                {viewingQaThread.messages?.map((msg, idx) => (
                  <div key={idx} className={`p-4 rounded-lg ${msg.sender_role === 'client' ? 'bg-blue-50 ml-8' : msg.sender_role === 'psychologist' ? 'bg-green-50 mr-8' : 'bg-blue-50'}`}>
                    <div className="flex justify-between items-start mb-2">
                      <p className="font-semibold text-sm">
                        {msg.sender_role === 'client' ? viewingQaThread.client_name : msg.sender_role === 'psychologist' ? viewingQaThread.psychologist_name : 'Admin'}
                      </p>
                      <p className="text-xs text-gray-500">{new Date(msg.timestamp).toLocaleString()}</p>
                    </div>
                    <p className="text-sm">{msg.message}</p>
                    {msg.attachments && msg.attachments.length > 0 && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-600 mb-1">Attachments:</p>
                        {msg.attachments.map((att, i) => (
                          <span key={i} className="text-xs bg-gray-200 px-2 py-1 rounded mr-2">📎 {att}</span>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
              {/* Admin Reply Section */}
              {viewingQaThread.status !== 'resolved' && (
                <div className="border-t pt-4">
                  <h4 className="font-semibold text-lg mb-3">Send Reply (as Admin)</h4>
                  <Textarea
                    value={adminReply}
                    onChange={(e) => setAdminReply(e.target.value)}
                    placeholder="Type your reply here..."
                    className="min-h-[100px] mb-3"
                    disabled={sendingReply}
                  />
                  <div className="flex justify-between gap-3">
                    <Button 
                      variant="outline" 
                      onClick={handleEndChat}
                      disabled={endingChat || sendingReply}
                      className="text-red-600 border-red-300 hover:bg-red-50"
                    >
                      {endingChat ? 'Ending...' : 'End Chat'}
                    </Button>
                    <div className="flex gap-3">
                      <Button 
                        variant="outline" 
                        onClick={() => {
                          setShowQaThreadModal(false);
                          setAdminReply('');
                        }}
                      >
                        Cancel
                      </Button>
                      <Button 
                        onClick={handleAdminReply}
                        disabled={sendingReply || !adminReply.trim()}
                        style={{ background: '#2563eb' }}
                      >
                        {sendingReply ? 'Sending...' : 'Send Reply'}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              
              {viewingQaThread.status === 'resolved' && (
                <div className="flex justify-end gap-3">
                  <Button variant="outline" onClick={() => setShowQaThreadModal(false)}>
                    Close
                  </Button>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
      
      {/* Feedback Reply Modal */}
      <Dialog open={showFeedbackReplyModal} onOpenChange={setShowFeedbackReplyModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Reply to Feedback
            </DialogTitle>
          </DialogHeader>
          {selectedFeedback && (
            <div className="space-y-4">
              {/* Original Feedback */}
              <div className="p-4 bg-gray-50 rounded-lg border">
                <div className="grid grid-cols-2 gap-2 mb-3">
                  <div>
                    <p className="text-xs text-gray-600">User</p>
                    <p className="font-semibold text-sm">{selectedFeedback.user_name}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-600">Category</p>
                    <p className="font-semibold text-sm">{selectedFeedback.category}</p>
                  </div>
                </div>
                <p className="text-xs text-gray-600 mb-1">Original Message:</p>
                <p className="text-sm">{selectedFeedback.message}</p>
                {selectedFeedback.admin_reply && (
                  <div className="mt-3 pt-3 border-t">
                    <p className="text-xs text-gray-600 mb-1">Previous Reply:</p>
                    <p className="text-sm text-blue-700">{selectedFeedback.admin_reply}</p>
                  </div>
                )}
              </div>
              
              {/* Reply Input */}
              <div>
                <label className="block text-sm font-semibold mb-2">Your Reply</label>
                <Textarea
                  value={feedbackReply}
                  onChange={(e) => setFeedbackReply(e.target.value)}
                  placeholder="Type your reply to the user..."
                  className="min-h-[120px]"
                  disabled={sendingFeedbackReply}
                />
                <p className="text-xs text-gray-500 mt-2">
                  ℹ️ This reply will be visible to the user in their dashboard.
                </p>
              </div>
              
              <div className="flex justify-end gap-3">
                <Button 
                  variant="outline" 
                  onClick={() => {
                    setShowFeedbackReplyModal(false);
                    setFeedbackReply('');
                  }}
                  disabled={sendingFeedbackReply}
                >
                  Cancel
                </Button>
                <Button 
                  onClick={handleFeedbackReply}
                  disabled={sendingFeedbackReply || !feedbackReply.trim()}
                  style={{ background: '#2563eb' }}
                >
                  {sendingFeedbackReply ? 'Sending...' : 'Send Reply'}
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    
      {/* Delete Feedback Confirmation Modal */}
      <Dialog open={showDeleteFeedbackModal} onOpenChange={setShowDeleteFeedbackModal}>
        <DialogContent className="max-w-[450px]">
          <DialogHeader>
            <DialogTitle className="text-red-600" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Delete Feedback
            </DialogTitle>
          </DialogHeader>
          
          <div className="py-4">
            <p className="text-sm text-gray-700 mb-4">
              Are you sure you want to delete this feedback? This action cannot be undone.
            </p>
            
            {selectedFeedbackForDelete && (
              <div className="p-3 bg-gray-50 border border-gray-300 rounded-lg">
                <p className="text-xs text-gray-600 mb-1">
                  From: {selectedFeedbackForDelete.user_name} ({selectedFeedbackForDelete.user_role})
                </p>
                <p className="text-xs text-gray-600 mb-1">Category: {selectedFeedbackForDelete.category}</p>
                <p className="text-sm text-gray-800 line-clamp-3">{selectedFeedbackForDelete.message}</p>
              </div>
            )}
          </div>
          
          <div className="flex justify-end gap-2">
            <Button 
              variant="outline" 
              onClick={() => setShowDeleteFeedbackModal(false)}
              disabled={deletingFeedback}
            >
              Cancel
            </Button>
            <Button 
              variant="destructive" 
              onClick={confirmDeleteFeedback}
              disabled={deletingFeedback}
            >
              {deletingFeedback ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      {/* Psychologist Detail Modal */}
      <Dialog open={showPsychologistDetailModal} onOpenChange={setShowPsychologistDetailModal}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Psychologist Details</DialogTitle>
          </DialogHeader>
          {selectedPsychologist && (
            <div className="space-y-6">
              <AdminPublicProfile key={selectedPsychologist.id} identifier={selectedPsychologist.id} />
              {/* Profile Photo Section */}
              <div className="flex items-center gap-6">
                {selectedPsychologist.proforma?.photo_url ? (
                  <img 
                    src={`${API}${selectedPsychologist.proforma.photo_url}`}
                    alt={selectedPsychologist.name}
                    className="w-32 h-32 object-cover rounded-full border-4 border-blue-200"
                  />
                ) : (
                  <div className="w-32 h-32 rounded-full bg-blue-100 flex items-center justify-center border-4 border-blue-200">
                    <Brain className="w-16 h-16 text-blue-600" />
                  </div>
                )}
                <div>
                  <h3 className="text-2xl font-bold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    {selectedPsychologist.name}
                  </h3>
                  <p className="text-gray-600">{selectedPsychologist.email}</p>
                </div>
              </div>
              
              {/* Basic Info Grid */}
              <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
                <div>
                  <Label className="font-semibold text-gray-700">Specialization:</Label>
                  <p className="mt-1">{selectedPsychologist.proforma?.specialization || 'Not provided'}</p>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">Experience:</Label>
                  <p className="mt-1">{selectedPsychologist.proforma?.experience_years ? `${selectedPsychologist.proforma.experience_years} years` : 'Not provided'}</p>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">Registration Number:</Label>
                  <p className="mt-1">{selectedPsychologist.registration_number || 'Not provided'}</p>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">License Number:</Label>
                  <p className="mt-1">{selectedPsychologist.license_number || 'Not provided'}</p>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">Approval Status:</Label>
                  <span className={`inline-block mt-1 px-3 py-1 text-xs rounded-full ${
                    selectedPsychologist.approval_status === 'approved' ? 'bg-green-100 text-green-800' :
                    selectedPsychologist.approval_status === 'rejected' ? 'bg-red-100 text-red-800' :
                    'bg-orange-100 text-orange-800'
                  }`}>
                    {selectedPsychologist.approval_status}
                  </span>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">Account Status:</Label>
                  <span className={`inline-block mt-1 px-3 py-1 text-xs rounded-full ${
                    selectedPsychologist.is_active !== false ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                  }`}>
                    {selectedPsychologist.is_active !== false ? '✓ Active' : '✕ Deactivated'}
                  </span>
                </div>
                <div>
                  <Label className="font-semibold text-gray-700">Average Rating:</Label>
                  <p className="mt-1">{selectedPsychologist.average_rating ? `${selectedPsychologist.average_rating.toFixed(1)} ⭐` : 'No ratings yet ⭐'}</p>
                </div>
              </div>
              
              {/* Qualifications */}
              {selectedPsychologist.proforma?.qualifications && (
                <div className="p-4 border rounded-lg">
                  <Label className="font-semibold text-gray-700 text-base">Qualifications:</Label>
                  <p className="mt-2 text-sm text-gray-600 whitespace-pre-wrap">
                    {selectedPsychologist.proforma.qualifications}
                  </p>
                </div>
              )}
              
              {/* Bio */}
              {selectedPsychologist.proforma?.bio && (
                <div className="p-4 border rounded-lg">
                  <Label className="font-semibold text-gray-700 text-base">Bio:</Label>
                  <p className="mt-2 text-sm text-gray-600 whitespace-pre-wrap">
                    {selectedPsychologist.proforma.bio}
                  </p>
                </div>
              )}
              
              {/* Languages */}
              {selectedPsychologist.proforma?.languages && (
                <div className="p-4 border rounded-lg">
                  <Label className="font-semibold text-gray-700 text-base">Languages:</Label>
                  <p className="mt-2 text-sm text-gray-600">
                    {selectedPsychologist.proforma.languages}
                  </p>
                </div>
              )}
              
              {/* Action Buttons */}
              <div className="flex justify-between gap-2 pt-4 border-t">
                <Button 
                  variant={selectedPsychologist.is_active !== false ? "destructive" : "default"}
                  onClick={() => {
                    handleToggleActivation(selectedPsychologist.id, selectedPsychologist.is_active !== false);
                  }}
                  className={selectedPsychologist.is_active !== false ? "" : "bg-green-600 hover:bg-green-700"}
                >
                  {selectedPsychologist.is_active !== false ? '🔒 Deactivate Account' : '✅ Activate Account'}
                </Button>
                <Button 
                  variant="outline" 
                  onClick={() => setShowPsychologistDetailModal(false)}
                >
                  Close
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
      
      {/* Consent Modal */}
      <ConsentModal 
        isOpen={showConsentModal} 
        onConsentGiven={() => setShowConsentModal(false)} 
      />
      
      <NotificationModal
        isOpen={notification.isOpen}
        onClose={closeNotification}
        type={notification.type}
        title={notification.title}
        message={notification.message}
      />
    </div>
  );
};

export default AdminDashboard;
